import http from '@services/http';
export default {
  login(token) {
    return http.get('Auth/Login', {
      token: token
    });
  }

};